var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-records"},[_c('img',{attrs:{"src":require("../../../assets/img/no-record.png")}}),_c('span',[_vm._v("暂无记录")])])
}]

export { render, staticRenderFns }